export enum GtmAction {
  NAVIGATION_DRAWER = "Side navigation panel",
  APP_BAR = "Top navigation panel",
  MSP_DASHBOARD_WIDGET = "MSP dashboard",
  WORKSPACE_VIEW_DASHBOARD_WIDGET = "Workspace view dashboard",
  WORKSPACE_SELECTOR = "Workspace selector",
  MSP_WORKSPACE_SELECTOR = "MSP workspace selector",
  SECURITY_GAPS_PAGE = "Security gaps page",
  CORO_INSIGHTS_PAGE = "Coro insights page",
  TICKETS = "Tickets Page",
  REPORTS = "Reports Page",
  SETUP_HUB = "Setup Hub",
  MSP_TREEVIEW = "Msp treeview",
  MSP_LIST_VIEW = "Msp list view",
  MSP_WORKSPACE_PAGE = "Msp workspace page",
  // unconventional legacy events. We should use pattern trackGtm(ELEMENT/AREA, WHAT IS CLICKED)
  SIGNUP_CLICKED = "Signup clicked",
  DEMO_MODE_STARTED = "Demo mode started",
  CONVERT_TO_TRIAL_CLICKED = "Convert to trial clicked",
}

export enum GTMParams {
  // Navigation Drawer
  LOGO = "Logo",
  LISTS_MENU = "Lists menu",
  MORE_MENU = "More menu",
  MESSAGES = "Messages",

  // App Bar
  AI_ASSISTANT_BUTTON_CLICKED = "AI Assistant Button clicked",
  ASK_CORO_BUTTON_CLICKED = "Ask Coro Button clicked",

  // MSP tree and list view
  WORKSPACE_NAME_CLICK = "Workspace click",
  FILTER_ONLY_CHANNEL_WORKSPACES = "Show only channel workspaces",
  WORKSPACE_STATISTICS_CLICK = "Workspace statistics",
  CHILD_WORKSPACES_TABLE_CLICK = "Child workspaces table",
  WORKSPACE_ACTIONS_CLICK = "Workspace actions",
  VIEW_WORKSPACE_CLICK = "View workspace",
  ROOT_WORKSPACE_CLICK = "Root channel",
  VIEW_PROTECTABLE_USERS = "View protectable users",
  TOP_ACTION_BTN = "Top action button clicked",

  // Workspace Selector
  WORKSPACE_SELECTED = "Workspace selected",
  SELECTOR_OPENED = "Selector opened",
  MSP_MODAL_OPENED = "MSP Modal - opened",
  MSP_MODAL_WORKSPACE_SELECTED = "MSP Modal - Workspace selected",

  // MSP Dashboard Widgets
  WORKSPACE_WIDGET_EXPIRING_SOON = "Workspace widget - Expiring soon",
  WORKSPACE_WIDGET_ALL = "Workspace widget - All",
  WORKSPACE_WIDGET = "Workspace widget",
  TICKETS_BREAKDOWN_WIDGET_PER_MODULE = "Tickets breakdown widget - Per Module",
  TICKETS_BREAKDOWN_WIDGET_PER_WORKSPACE_ID = "Tickets breakdown widget - Per Workspace Id",
  USERS_WIDGET_SUSPENDED = "Users widget - Suspended",
  USERS_WIDGET = "Users widget",
  DEVICE_WIDGET_ISOLATED = "Device widget - Isolated",
  DEVICE_WIDGET_ALL = "Device widget - All",
  GENERATED_TICKETS_WIDGET = "Generated tickets widget",
  HEALTH_SCORE = "Healthscore",
  TICKETS_MGMT = "Tickets Management",

  // Coro Insights Page
  TOP_SUSPICIOUS_DOMAINS_DOMAIN_CLICKED = "Top suspicious domains",
  USER_CLICKED = "user clicked",
  AUTO_RESOLVED_TICKETS_ALL = "Auto resolved tickets - All",
  CORO_INSIGHTS_TICKETS_WIDGET = "Tickets widget",

  // Workspace View Dashboard Widgets
  SAT_WIDGET = "SAT widget",
  SECURITY_GAPS = "Security Gaps",
  SUMMARY_WIDGET = "Summary widget",
  SUBSCRIPTION_OVERVIEW = "Subscription overview",
  SUBSCRIPTION_OVERVIEW_SEE_ADDONS = "Subscription overview - See add-ons",
  MODULE = "module",
  ADDON = "addon",
  TOTAL_PROTECTED_USERS_AND_DEVICES = "Total protected users and devices",
  DEVICE_WIDGET = "Device widget",
  TICKET_TYPE = "Ticket type",
  ALL = "All",
  SETTINGS_ICON = "Settings Icon",
  VIEW_DEVICES = "View devices",
  VIEW_USERS = "View users",
  CONNECTION_STATUS = "Connection status",
  OVERVIEW_WIDGET_CLICKED = "Overview widget clicked",

  // Ticket Details
  TICKET_DETAILS = "Ticket details",
  TAB = "tab",
  EMAIL_CLOUD_FINDINGS_CLICKED = "Email/cloud findings clicked",
  DEVICE_FINDINGS_CLICKED = "Device findings clicked",
  EMAIL_FINDINGS_CLICKED = "Email findings clicked",
  QUICK_FIX = "Quick fix clicked",

  // Vulnerabilities
  SHOW_MORE_VULNERABILITIES = "Show more vulnerabilities",
  SHOW_LESS_VULNERABILITIES = "Show less vulnerabilities",

  MSP = "Msp",
  SINGLE_VIEW = "Single View",
  // Setup hub
  SKIPPED = "Skipped",
  ACTION_CLICKED = "Action clicked",
  HELP_LINK_CLICKED = "Help link clicked",

  // Generic
  OPENED = "Opened",
  CLICKED = "clicked",
  DISMISSED = "Dismissed",
  CLOSED = "Closed",
}
